import type { ReactNode } from 'react';
import { Box } from '@uhg-abyss/web/ui/Box';

interface PageShellProps {
  children: ReactNode;
}

/**
 * Mobile-first page container. Constrains content to `max-w-md` — the WebView
 * primary target is 320–414px phones — with consistent horizontal centering
 * and base padding. Use as the outermost wrapper for every route.
 */
export default function PageShell({ children }: PageShellProps) {
  return (
    <Box
      css={{
        minHeight: '100%',
        backgroundColor: '$gray50',
        display: 'flex',
        flexDirection: 'column',
      }}
      color=""
    >
      <Box
        css={{
          maxWidth: '28rem',
          marginLeft: 'auto',
          marginRight: 'auto',
          width: '100%',
          minHeight: '100%',
          backgroundColor: '$white',
          display: 'flex',
          flexDirection: 'column',
        }}
        color=""
      >
        {children}
      </Box>
    </Box>
  );
}
